import {
  Camera,
  Shield,
  ShieldAlert,
  Flame,
  Network,
  ShieldCheck,
  Clock,
  Wrench,
  Sparkles,
  Boxes,
  Phone,
  Mail,
  MapPin,
  Menu,
  X,
  Send,
  MessageCircle,
  ChevronLeft,
  Star,
  CheckCircle2,
} from "lucide-react";

const MAP = {
  camera: Camera,
  shield: Shield,
  "shield-alert": ShieldAlert,
  "shield-check": ShieldCheck,
  flame: Flame,
  network: Network,
  clock: Clock,
  wrench: Wrench,
  sparkles: Sparkles,
  boxes: Boxes,
  phone: Phone,
  mail: Mail,
  "map-pin": MapPin,
  menu: Menu,
  x: X,
  send: Send,
  "message-circle": MessageCircle,
  "chevron-left": ChevronLeft,
  star: Star,
  "check-circle": CheckCircle2,
};

export default function Icon({ name, className = "", size = 24, strokeWidth = 1.75 }) {
  const Cmp = MAP[name] || Shield;
  return <Cmp className={className} size={size} strokeWidth={strokeWidth} />;
}
